"use strict";

var _ = require("bower_components/lodash/dist/lodash.js");

// module
require("core/core.module.js");
require("bower_components/angular-loading-bar/build/loading-bar.min.js");
require("node_modules/angular-auto-complete/angular-auto-complete.js");
require("node_modules/angular-bootstrap-toggle/dist/angular-bootstrap-toggle.js");
require("node_modules/ng-tags-input/build/ng-tags-input.js");

require("vendor/app-core/availability-status/availability-status.module.js");
require("vendor/app-core/drag-scroll/drag-scroll.module.js");


// CSS
require("vendor/scss/app.scss");
require("bower_components/angular-loading-bar/build/loading-bar.min.css");
require("node_modules/angular-auto-complete/angular-auto-complete.css");
require("node_modules/angular-bootstrap-toggle/dist/angular-bootstrap-toggle.css");
require("node_modules/ng-tags-input/build/ng-tags-input.css");
require("assets/css/lato.css");

angular.module("vendor", [
    "core",
    "angular-loading-bar",
    "autoCompleteModule",
    "ui.toggle",
    "ngTagsInput",
    "dndLists",
    "preventUnsavedChanges",
    "availabilityStatus",
    "dragScroll",
])

.constant("appConfig", {
    APP: "vendor",
    API_SERVER: window.app.APIServer,
    VENDOR_URL: window.app.VENDOR_URL,
    ENV_NAME: window.app.ENV_NAME,
    ROOT_DOMAIN: window.app.ROOT_DOMAIN,
    ENV_SUB_DOMAIN: window.app.ENV_SUB_DOMAIN,
    ROLLBAR_ACCESS_TOKEN: window.app.ROLLBAR_ACCESS_TOKEN,
    AWS_COGNITO_CLIENT_ID: window.app.AWS_COGNITO_CLIENT_ID,
    AWS_COGNITO_DOMAIN_URL: window.app.AWS_COGNITO_DOMAIN_URL
})
.constant("APP_OWNER", "wegotrade")

.config(function($resourceProvider) {
    $resourceProvider.defaults.stripTrailingSlashes = false;
})
.config(["$locationProvider", function($locationProvider) {
    // removes angular hash (#) from urls
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
    });
}])
.config(["cfpLoadingBarProvider", function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.parentSelector = "#loading-bar-container";
    /* Default templates are here: https://github.com/chieffancypants/angular-loading-bar/blob/master/src/loading-bar.js#L169-L170
    Activate the spinner here
    */
    cfpLoadingBarProvider.includeSpinner = true;
    cfpLoadingBarProvider.includeBar = true;

    cfpLoadingBarProvider.autoIncrement = true;
    cfpLoadingBarProvider.latencyThreshold = 100;
    cfpLoadingBarProvider.startSize = 0.02;
    cfpLoadingBarProvider.spinnerTemplate = "<div id=\"loading-bar-spinner-wrapper\"><div id=\"loading-bar-spinner\"><div class=\"spinner-icon\"></div></div></div>";
    cfpLoadingBarProvider.loadingBarTemplate = "<div></div>";
}])
.config(['RollbarProvider', 'appConfig', function(RollbarProvider, appConfig) {
    RollbarProvider.init({
        accessToken: appConfig.ROLLBAR_ACCESS_TOKEN,
        captureUncaught: true,
        payload: {
            environment: appConfig.ENV_NAME + " app-" + appConfig.APP
        }
    });
}])
.run(function(Rollbar, IGNORED_MESSAGES) {
    Rollbar.configure({ignoredMessages: IGNORED_MESSAGES});
})
.run(function() {
    // clean confidential information accessibility for security purpose
    delete window.app.ENV_NAME;
    delete window.app.ROOT_DOMAIN;
    delete window.app.ENV_SUB_DOMAIN;
    delete window.app.APIServer;
    delete window.app.VENDOR_URL;
    delete window.app.ROLLBAR_ACCESS_TOKEN;
    delete window.app.AWS_COGNITO_CLIENT_ID;
    delete window.app.AWS_COGNITO_DOMAIN_URL;
})
.run(function(appConfig, NavBarToggleService) {
    window.PageType = appConfig;
    NavBarToggleService.activateAutoCollapse();
})
.run(function(FlashBag) {
    FlashBag.setSuccessMessageLifetime(15000);
})
.run(function(gettextCatalog) {
    gettextCatalog.debug = true;
})
.run(function($rootScope) {
    $rootScope.meta = {}; // initialitation
    $rootScope.meta.appTitle = "Vendor - WeGoTrade";
})

.controller("rootCtrl", function($rootScope, $scope, Language, $state, gettextCatalog) {
    Language.init();
    Language.initializeScope($scope, "language", null);

    $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        if (!$state.current.authenticate) {
            if ($state.current.meta) {
                $rootScope.meta.pageTitle = $state.current.meta.title(gettextCatalog);
                $rootScope.meta.description = $state.current.meta.description(gettextCatalog);
                $rootScope.meta.keywords = $state.current.meta.keywords(gettextCatalog);
            }
            else {
                $rootScope.meta.pageTitle = gettextCatalog.getString("default meta title");
                $rootScope.meta.description = gettextCatalog.getString("default meta description");
                $rootScope.meta.keywords = gettextCatalog.getString("default meta keywords");
            }
        }
    });
});

require("vendor/I18n.js");
require("vendor/vendor.route.js");

require("vendor/layout/layout.directive.js");
require("vendor/header/header.controller.js");

require("vendor/app-core/localized-form/localized-form.component.js");
require("vendor/app-core/vendor-types/vendor-types.service.js");
require("vendor/app-core/filter-by/filter-by.component.js");
require("vendor/app-core/enabled-checkbox/enabled-checkbox.component.js");
require("vendor/app-core/scroll/scroll.directive.js");
require("vendor/app-core/only-digits/only-digits.directive.js");
require("vendor/app-core/import-results/import-results.modal.js");
require("vendor/app-core/product-sequence/product-sequence.service.js");
require("vendor/app-core/mptt-industry-selector/mptt-industry-selector.component.js");
require("vendor/app-core/mptt-industry-selector/mptt-industry-selector.modal.js");
require("vendor/app-core/industry-filter/industry-filter.component.js");
require("vendor/app-core/partnership-status-filter/partnership-status-filter.service.js");
require("vendor/app-core/sales-rep-status-filter/sales-rep-status-filter.service.js");
require("vendor/app-core/sales-rep-status-filter/sales-rep-status-filter.component.js");
require("vendor/app-core/financial-status-filter/financial-status-filter.service.js");
require("vendor/app-core/financial-status-filter/financial-status-filter.component.js");
require("vendor/app-core/partnership-tag-filter/partnership-tag.service.js");
require("vendor/app-core/zone/zone.service.js");
require("vendor/app-core/market/market.directive.js");
require("vendor/app-core/zone-filter/zone-selector.modal.js");
require("vendor/app-core/zone-filter/zone-filter.component.js");
require("vendor/app-core/model-management/rebroadcast-reset-listing.directive.js");
require("vendor/app-core/model-management/model-management.directive.js");
require("vendor/app-core/model-management/partnership-model-management.directive.js");
require("vendor/app-core/model-management/partnership-selector-unregistered-service.factory.js");
require("vendor/app-core/model-management/order-selector-unregistered-service.factory.js");
require("vendor/app-core/model-management/order-model-management.directive.js");
require("vendor/app-core/customer-details-modal/customer-details.component.js");
require("vendor/app-core/customer-details-modal/customer-details.modal.js");
require("vendor/app-core/partnership-inline/partnership-inline.component.js");
require("vendor/app-core/sales-rep-inline/sales-rep-inline.component.js");
require("vendor/app-core/industry-inline/industry-inline.component.js");
require("vendor/app-core/delivery-schedule-inline/delivery-schedule-inline.component.js");
require("vendor/app-core/business-views-nav/business-views-nav.component.js");
require("vendor/app-core/model-management/payment-model-management.directive.js");
require("vendor/app-core/model-management/payment-selector-unregistered-service.factory.js");
require("vendor/app-core/model-management/invoice-model-management.directive.js");
require("vendor/app-core/model-management/invoice-selector-unregistered-service.factory.js");
require("vendor/app-core/partnership-unpaid-invoices-statement-print-button/partnership-unpaid-invoices-statement-print-button.service.js");
require("vendor/app-core/partnership-unpaid-invoices-statement-print-button/partnership-unpaid-invoices-statement-print-button.component.js");
require("vendor/app-core/delivery-date-filter/delivery-date-filter.component.js");


// Constants
require("vendor/sections/catalog/catalog.constants.js");
require("vendor/sections/sale-representative/sale-representative.constants.js");
require("vendor/app-core/quickbooks/quickbooks.constant.js");


// Factory/Service
require("vendor/sections/customer/partnership.service.js");
require("vendor/sections/customer/customer-manage.service.js");
require("vendor/sections/customer/customer-to-approve.service.js");
require("vendor/sections/customer/customer-send-reminder.service.js");
require("vendor/sections/customer/customer-send-notification.service.js");
require("vendor/sections/customer/customer-financial.service.js");
require("vendor/sections/product/product.service.js");
require("vendor/sections/product/unit-of-measure.service.js");
require("vendor/sections/product/barcode-format.service.js");
require("vendor/sections/product/views/sequence/product-sequence-reorder.service.js");
require("vendor/sections/catalog/catalog.factory.js");
require("vendor/sections/catalog/catalog-entry.service.js");
require("vendor/sections/catalog/catalog-entry-variants.service.js");
require("vendor/sections/catalog/catalog-buyer.factory.js");
require("vendor/sections/catalog/catalog-dashboard/catalog-dashboard.factory.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-discount/discount.service.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-rebate/rebate.service.js");
require("vendor/sections/support/support-vendor.service.js");
require("vendor/sections/sale-representative/sale-representative.service.js");
require("vendor/sections/sale-representative/sale-representative-assignment.factory.js");
require("vendor/sections/sale-representative/sale-representative-assigned.factory.js");
require("vendor/sections/shipping-rate/shipping-rate.service.js");
require("vendor/sections/order/vendor-order.service.js");
require("core/bootstrap-helper/nav-bar-toggle.service.js");
require("vendor/sections/payment/vendor-payment.service.js");
require("vendor/sections/invoice/vendor-invoice.service.js");
require("vendor/sections/report/reports.service.js");
require("vendor/sections/product/product-variants/product-variants.service.js");


// Modal
require("vendor/sections/product/views/sequence/product-view-sequence-form.modal.js");
require("vendor/sections/product/views/sequence/export-sequence.modal.js");
require("vendor/sections/product/views/sequence/import-sequence.modal.js");
require("vendor/sections/product/product-variants/modals/product-variant.modal.js");
require("vendor/sections/catalog/btn-clone/confirmation.modal.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-rebate/catalog-entry-rebate.modal.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-discount/catalog-entry-discount.modal.js");
require("vendor/sections/customer/partnership-form/partnership-candidate-customers.modal.js");
require("vendor/sections/customer/modals/create-user-customer-manager.modal.js");
require("vendor/app-core/action-modal/group-partnership-confirmation.modal.js");
require("vendor/app-core/action-modal/partnership-send-notification-confirmation.modal.js");
require("vendor/app-core/action-modal/partnership-financial-credit-limit-confirmation.modal.js");
require("vendor/app-core/action-modal/partnership-financial-overdue-confirmation.modal.js");
require("vendor/app-core/action-modal/partnership-financial-payment-methods-confirmation.modal.js");
require("vendor/app-core/action-modal/partnership-financial-pre-authorized-payment-methods-confirmation.modal.js");
require("vendor/app-core/action-modal/partnership-financial-pre-authorized-payment-agreement-type-confirmation.modal.js");
require("vendor/app-core/action-modal/email-order-confirmation.modal.js");
require("vendor/app-core/action-modal/email-invoice-confirmation.modal.js");


// Component/Directives
require("vendor/sections/product/product-form/product-form.component.js");
require("vendor/sections/product/product-variants/product-variants.component.js");
require("vendor/sections/product/product-deposits/product-deposits.component.js");
require("vendor/sections/product/views/detailed/product-view-detailed-listing.component.js");
require("vendor/sections/product/views/sequence/product-view-sequence-listing.component.js");
require("vendor/sections/catalog/views/catalog-view-detail-listing.directive.js");
require("vendor/sections/catalog/views/catalog-view-status-listing.directive.js");
require("vendor/sections/catalog/catalog-dashboard/catalog-dashboard.component.js");
require("vendor/sections/catalog/btn-clone/btn-clone.component.js");
require("vendor/sections/catalog/catalog-authorized-customer/catalog-authorized-customer/catalog-authorized-customer.component.js");
require("vendor/sections/catalog/group-authorized-customer/group-authorized-customer/group-authorized-customer.component.js");
require("vendor/sections/catalog/product-auto-complete/product-auto-complete.component.js");
require("vendor/sections/product/product-deposits/product-deposit-auto-complete/product-deposit-auto-complete.component.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-tab.component.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-product-add.component.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-product-variant-add.component.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-discount/catalog-entry-discount.component.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-rebate/catalog-entry-rebate.component.js");
require("vendor/sections/catalog/catalog-entry-tab/catalog-entry-variants/catalog-entry-variants.component.js");
require("vendor/sections/catalog/group-authorized-customer/group-add-section/group-add-section.component.js");
require("vendor/sections/catalog/group-authorized-customer/group-manage-section/group-manage-section.component.js");
require("vendor/sections/catalog/catalog-authorized-customer/catalog-add-section/catalog-add-section.component.js");
require("vendor/sections/catalog/catalog-authorized-customer/catalog-manage-section/catalog-manage-section.component.js");
require("vendor/sections/customer/partnership-form/partnership-form.component.js");


// Controller
require("vendor/sections/home/home.controller.js");
require("vendor/sections/auth/login.controller.js");
require("vendor/sections/auth/vendor.controller.js");
require("vendor/sections/auth/registration.controller.js");
require("vendor/sections/auth/user-info.factory.js");
require("vendor/sections/catalog/catalog-list.controller.js");
require("vendor/sections/catalog/catalog-edit.controller.js");
require("vendor/sections/catalog/catalog-authorized-customer/catalog-authorized-customer/abstract-catalog-authorized-section.controller.js");
require("vendor/sections/catalog/group-authorized-customer/group-authorized-customer/abstract-group-authorized-customer.controller.js");
require("vendor/sections/product/product-list.controller.js");
require("vendor/sections/product/product-edit.controller.js");
require("vendor/sections/product/product-add.controller.js");
require("vendor/sections/order/order-detail.controller.js");
require("vendor/sections/order/order-list.controller.js");
require("vendor/sections/order/order-log.controller.js");
require("vendor/sections/invoice-attachment/invoice-attachment.controller.js");
require("vendor/sections/customer/customer-manage.controller.js");
require("vendor/sections/customer/customer-to-approve.controller.js");
require("vendor/sections/customer/customer-send-reminder.controller.js");
require("vendor/sections/customer/customer-send-notification.controller.js");
require("vendor/sections/customer/customer-financial.controller.js");
require("vendor/sections/customer/customer-edit.controller.js");
require("vendor/sections/customer/customer-add.controller.js");
require("vendor/sections/sale-representative/sale-representative-list.controller.js");
require("vendor/sections/sale-representative/modals/modify-sales-representative-user-password.modal.js");
require("vendor/sections/sale-representative/sale-representative-edit.controller.js");
require("vendor/sections/sale-representative/sale-representative-edit/sale-representative-edit.component.js");
require("vendor/sections/sale-representative/sale-representative-edit/abstract-sale-representative-edit.controller.js");
require("vendor/sections/sale-representative/add-section/sale-representative-add-section.component.js");
require("vendor/sections/sale-representative/manage-section/sale-representative-manage-section.component.js");
require("vendor/sections/import/import.controller.js");
require("vendor/sections/import/import-document-list.controller.js");
require("vendor/sections/import/import-log-list.controller.js");
require("vendor/sections/support/support-vendor-list.controller.js");
require("vendor/sections/shipping-rate/shipping-rate-list.controller.js");
require("vendor/sections/shipping-rate/shipping-rate-edit.controller.js");
require("vendor/sections/invoice/invoice-list.controller.js");
require("vendor/sections/invoice/invoice-detail.controller.js");
require("vendor/sections/payment-settings/payment-settings.controller.js");
require("vendor/sections/report/report.controller.js");
require("vendor/sections/payment/payment-list.controller.js");
require("vendor/sections/payment/payment-details.controller.js");
require("vendor/sections/integration/quickbooks/quickbooks-revoke.controller.js");

require("vendor/header/search-bar.html");
require("vendor/header/web-navigation.html");
require("vendor/header/mobile-navigation.html");
require("vendor/header/web-navigation-without-user-agreement.html");
require("vendor/header/mobile-navigation-without-user-agreement.html");



//////////////////
// WEBPACK FOOTER
// ./vendor/vendor.module.js
// module id = 2
// module chunks = 0